import { createAsyncReducer } from '../../standard-actions/';
import { ILoadInternetProductDnsDetailsAction,
    ILoadInternetProductDnsDetailsErrorAction,
    ILoadInternetProductDnsDetailsSuccessAction } from '../actions/load-internet-product-dns-details';

import { IServiceRequestsState } from '../state';
import { initialState } from '@telstra-connect/service-requests/state/initial-state';

export type InternetProductAction
    = ILoadInternetProductDnsDetailsAction
    | ILoadInternetProductDnsDetailsSuccessAction
    | ILoadInternetProductDnsDetailsErrorAction;

const init = (state: IServiceRequestsState, action: InternetProductAction) => ({
    ...state,
    internetProductDnsDetails: {
        ...initialState.internetProductDnsDetails,
        status: action.status,
    }
});

const success = (state: IServiceRequestsState, action: InternetProductAction) => ({
    ...state,
    internetProductDnsDetails: {
        ...initialState.internetProductDnsDetails,
        status: action.status,
        data: (action as ILoadInternetProductDnsDetailsSuccessAction).data
    }
});

const failure = (state: IServiceRequestsState, action: InternetProductAction) => ({
    ...state,
    internetProductDnsDetails: {
        ...initialState.internetProductDnsDetails,
        status: action.status,
        error: (action as ILoadInternetProductDnsDetailsErrorAction).error
    }
});

export const loadInternetProductDnsDetailsReducer = createAsyncReducer(initialState, init, success, failure);

